import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import ImageAssistantPanel from 'Pods/ThreeDStudio/Components/ImageAssistantPanel/ImageAssistantPanel'

import Header from './Components/Header/Header'
import LeftSide from './Components/LeftSide/LeftSide'
import RightSide from './Components/RightSide/RightSide'

function MainPanel({ hasViewerSidebar }) {
  return (
    <div className={classnames('main-panel', hasViewerSidebar && 'main-panel--with-viewer-sidebar')}>
      <Header />
      <div className="main-panel__content">
        <LeftSide />
        <RightSide />
      </div>
      {/* Sibling of the header (not nested in the content) so the panel overlays the
          "3D Model" header row too, right of the Generate form on desktop. */}
      <ImageAssistantPanel />
    </div>
  )
}

MainPanel.propTypes = {
  hasViewerSidebar: bool.isRequired,
}

export default memo(MainPanel)
